import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core'
import { AggregationDataset } from '../../../shared/interfaces/visualizations/aggregation-dataset.interface'
import { ChartData, ChartEvent, ChartOptions, plugins } from 'chart.js'
import { ColorService } from '../../../shared/services/color.service'
import { SmartLinkService } from '../../../shared/services/smart-link.service'
import { PieChartItem } from './interfaces/pie-chart-item'

@Component({
  selector: 'app-pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.scss']
})
export class PieChartComponent implements OnChanges {
  @Input() dataset: AggregationDataset

  @Input()
  chartType: 'pie' | 'doughnut' = 'pie';

  @Input()
  cutout = '45%';

  @Output()
  sliceClick = new EventEmitter<PieChartItem>();

  colors: string[] = [];

  pieChartOptions: ChartOptions<'pie' | 'doughnut'> = {
    responsive: true,
    cutout: this.cutout,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        callbacks: {
          title: (context) => {
            const item = this.dataset.data[context[0].dataIndex] as PieChartItem

            return item.label
          },

          label: (context) => {
            const item = this.dataset.data[context.dataIndex] as PieChartItem

            if (item.countryLabels?.length) {
              return [`Countries : ${item.value}`, ...item.countryLabels];
            }

            return `Countries : ${item.value}`
          }
        }
      }
    }
  }

  pieChartData: ChartData<'pie' | 'doughnut', number[], string | string[]>

  constructor(private smartLinkService: SmartLinkService) {}

  ngOnChanges(): void {
    this.colors = ColorService.getColors();
    this.pieChartData = {
      labels: this.dataset.data.map((d: PieChartItem) => d.label),
      datasets: [
        {
          data: this.dataset.data.map((d: PieChartItem) => d.value),
          backgroundColor: this.dataset.data.map(
            (d: PieChartItem, i: number) => this.colors[i]
          ),
          borderColor: this.dataset.data.map(
            (d: PieChartItem, i: number) => this.colors[i]
          )
        }
      ]
    }
    console.log(this.pieChartData);
  }

  chartClicked(event: {
    event?: ChartEvent
    active?: ({ index: number } | any)[]
  }): void {
    const clickedItem: PieChartItem = this.dataset.data[event.active[0].index]
    if (clickedItem.label === "No tax incentives for R&D and innovation") {
      return
    }
    this.sliceClick.emit(clickedItem);

    if (clickedItem?.link) {
      this.smartLinkService.goToLink(clickedItem.link)
    }
  }
}
